<app-alert-container></app-alert-container>
<app-modal-loader></app-modal-loader>
<router-outlet />
<app-dev-tools-panel />
<app-guided-tour></app-guided-tour>